<!-- 部门文件操作 -->
<template>
    <div>
        <el-drawer :close-on-press-escape="true" title="我是标题" :visible.sync="dataActionBox.showStatus"
            :with-header="false" :append-to-body="true" :direction="dataActionBox.openMode" size="40%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="formDataList" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form size="mini" inline :model="sendDataInfo" label-width="150px"
                                        ref="sendDataInfo" :show-message="false">

                                        <el-form-item label="部门" prop="depId"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('部门')"
                                                v-html="$common.htmlLabel('部门')"></label>
                                            <el-input clearable v-model="sendDataInfo.depName" class="form_codition"
                                                @keyup.enter.native="
                                                    openSearch(
                                                        '260885525041152',
                                                        0,
                                                        'depName',
                                                        'depId,depName'
                                                    )
                                                    ">
                                                <el-button @click="
                                                    openSearch(
                                                        '260885525041152',
                                                        0,
                                                        'depName',
                                                        'depId,depName'
                                                    )
                                                    " slot="append" icon="el-icon-search"></el-button></el-input>
                                        </el-form-item>
                                        <el-form-item label="文件" prop="files">
                                            <el-upload class="upload-demo" action="#" :http-request="customUpload"
                                                :multiple="true" :before-remove="beforeRemove"
                                                :before-upload="beforeUpload" :file-list="fileList" list-type="picture"
                                                :key="uploadKey">
                                                <el-button size="small" type="primary">点击上传</el-button>
                                                <!-- <div slot="tip" class="el-upload__tip">不超过500kb</div> -->
                                            </el-upload>
                                        </el-form-item>

                                        <el-form-item label="文件说明" prop="info">
                                            <label slot="label" :style="$common.labelStyle('文件说明')"
                                                v-html="$common.htmlLabel('文件说明')"></label>
                                            <el-input class="form_codition" v-model.trim="sendDataInfo.info"
                                                type="textarea" :maxlength="$store.state.inputLength"></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>

                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button type="primary" @click="dataActionBox.showStatus = false"
                        v-if="dataActionBox.actionType != 2">取消</el-button>
                    <el-button type="primary" @click="sendDataAction()"
                        v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction()"
                        v-if="dataActionBox.actionType == 1">保存</el-button>
                    <!-- <el-button type="primary" v-if="dataActionBox.actionType==3" @click="submitData()">提交供货商</el-button> -->
                </div>
            </div>

        </el-drawer>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth"
                @sendTitle="getSearchName" :parentSearchData="parentSearchData" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue"

export default {
    name: 'departmentFileManagementAction',
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                files: '',//文件
                attachFile: [],
                depId: '',
                depName: '',
                info: '',  //文件说明
            },
            formDataList: [],
            showTabs: '',
            allDepartmentList: [],
            requesUrl: "",
            token: {
                token: sessionStorage.getItem("token"),
            },
            fileList: [],
            srcList: [],
            imgUrl: '',
            uploadKey: 0, // 用于强制重新渲染 el-upload 组件
            //---------------
            seTitle: "",
            DialogVisible: false,
            seId: "",
            setField: "",
            setType: "",
            seWidth: "0",
            parentSearchData: {},
        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {

        // 自定义上传方法
        async customUpload(options) {
            const { file, onProgress, onSuccess, onError } = options;

            const formData = new FormData();
            formData.append('file', file);

            try {
                // 使用项目中定义的uploadFile API
                const response = await this.$http.uploadFile(formData);

                console.log('上传响应:', response);

                if (response.status === 200) {
                    // 上传成功，添加到文件列表和attachFile数组
                    response.result.forEach((item) => {
                        this.sendDataInfo.attachFile.push(item.fileUrl);
                    });

                    // 添加到显示列表，根据文件类型显示不同的URL
                    const displayUrl = this.getFileDisplayUrl(file.name, response.result[0].fileUrl);
                    this.fileList.push({
                        name: file.name,
                        url: displayUrl,
                        uid: file.uid
                    });

                    onSuccess(response);
                } else {
                    // 上传失败，显示错误消息但不添加到列表
                    this.$message({
                        type: 'error',
                        message: response.message || '文件上传失败'
                    });
                    onError(new Error(response.message || '文件上传失败'));
                }
            } catch (error) {
                console.error('上传错误:', error);
                this.$message({
                    type: 'error',
                    message: '文件上传失败: ' + (error.message || '网络错误')
                });
                onError(error);
            }
        },
        // 获取文件显示URL，PDF文件显示图标
        getFileDisplayUrl(fileName, fileUrl) {
            const fileExtension = fileName.split('.').pop().toLowerCase();
            if (fileExtension === 'pdf') {
                // PDF文件显示PDF图标
                return require('@/assets/pdf1.png');
            } else {
                // 其他文件显示实际图片
                return this.imgUrl ? `${this.imgUrl}/${fileUrl}` : fileUrl;
            }
        },
        beforeUpload(file) {
            for (let i = 0; i < this.sendDataInfo.attachFile.length; i++) {
                const v = this.sendDataInfo.attachFile[i]
                if (v.fileName == file.name) {
                    this.$message({
                        type: "error",
                        message: "请勿重复添加",
                    })
                    return false
                }
            }
            console.log(file, this.sendDataInfo.attachFile);
        },
        beforeRemove(file, fileList) {
            console.log(file, fileList)
            let index = 0
            for (let i = 0; i < fileList.length; i++) {
                const item = fileList[i];
                if (item == file.fileUrl) {
                    index = i
                    break
                }
            }
            this.sendDataInfo.attachFile.splice(index, 1)
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = ''
            }
            // 确保文件相关数据被正确重置
            this.sendDataInfo.attachFile = []
            this.fileList = []
            this.dataActionBox.actionType = 0
            this.dataActionBox.showStatus = false

        },

        async openBox(cate, oldData = '') {

            this.initActionBox()
            this.sendDataInfo.depCode = await this.$common.createDepartmentCode('', -1)

            // 清空文件列表，确保每次打开弹窗时都是干净的状态
            this.sendDataInfo.attachFile = [];
            this.fileList = []
            // 更新 uploadKey 强制重新渲染 el-upload 组件
            this.uploadKey = Date.now()

            if (cate == 0) {
                // 新增模式：保持空的文件列表
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
                this.showTabs = "新增部门文件信息"
                this.formDataList = [
                    {
                        jciName: "新增部门文件信息",
                        jurconfigform: [],
                    }
                ]
            } else {
                // 编辑模式：回显数据，包括文件列表
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'ltr'
                for (let key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }

                // 只有在编辑模式下才回显文件列表
                if (this.sendDataInfo.files != '') {
                    // 确保imgUrl已经初始化
                    if (!this.imgUrl) {
                        this.imgur();
                    }

                    let imgList = this.sendDataInfo.files.split(',')
                    this.sendDataInfo.attachFile = [...imgList]
                    imgList.forEach(item => {
                        // 从文件路径中提取文件名来判断文件类型
                        const fileName = item.split('/').pop() || item;
                        const displayUrl = this.getFileDisplayUrl(fileName, item);
                        this.fileList.push({
                            url: displayUrl,
                            name: fileName
                        })
                        console.log('回显文件:', { fileName, displayUrl });
                    })
                }
                this.formDataList = [
                    {
                        jciName: "编辑部门文件信息",
                        jurconfigform: [],
                    }
                ]
                this.showTabs = "编辑部门文件信息"

            }
            this.dataActionBox.actionType = cate

            // 使用 nextTick 确保 DOM 更新后再显示弹窗，避免 el-upload 组件渲染问题
            this.$nextTick(() => {
                this.dataActionBox.showStatus = true
            })

        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.seType = type
            this.DialogVisible = true
            this.seId = sId,
                this.sField = sField

        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
        },
        //检索方案返回的数据
        changeInputModel(val) {
            if (val) {
                this.paramValue(val)
            }
            this.DialogVisible = false
        },

        getSeWidth(e) {
            console.log(e)
            this.seWidth = e + "%"
        },
        getWidth(e) {
            console.log(e)
            this.exWidth = e + "%"
        },
        getSearchName(e) {
            console.log(e)
            this.seTitle = e
        },

        async sendDataAction() {
            var sendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
            // 将attachFile数组转换为逗号分隔的字符串
            sendDataInfo.files = sendDataInfo.attachFile.join(',')
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addDepartFile(sendDataInfo)
            } else {
                var responseData = await this.$http.updateDepartFile(sendDataInfo)
            }
            if (responseData.status == 200) {
                this.initActionBox()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });

                this.$parent.getDataList()

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },



    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgur();

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>

::v-deep .upload-demo ul {
   display: flex;
   align-items: baseline;
   flex-wrap: wrap;
}

::v-deep .upload-demo img {
   width: 30px;
   height: 30px;
   margin-left: 0px;
}

::v-deep .upload-demo .el-upload-list--picture .el-upload-list__item {
   width: 80px;
   height: 42px;
   padding: 5px 0px;
   padding-left: 5px;
}

/* PDF图标样式优化 */
::v-deep .upload-demo .el-upload-list--picture .el-upload-list__item img[src*="pdf1.png"] {
   object-fit: contain;
   background-color: #f5f5f5;
   border-radius: 4px;
}

</style>